module.exports = __webpack_public_path__ + "static/media/gdrive_icon.91097f68.svg";